export default __webpack_public_path__ + "static/media/Singing Teacher-595b40b75ba036ed117d8efe 1.f8cd4e55.svg";